export default "__VITE_ASSET__ddc899ee__"